<template>
  <div class="billing">
    <div class="billing-data">
      <div class="plan cell mb-16">
        <p class="text-xs">{{ trans.plan }}</p>
        <p v-if="!!subscription?.product?.name">{{ subscription.product.name }}</p>
        <p v-else>No data available</p>
      </div>

      <div class="amount mb-16">
        <p class="text-xs">{{ trans.amount }}</p>
        <p v-if="!!subscription?.price?.price?.string">{{ subscription.price.price.string }}</p>
        <p v-else>No data available</p>
      </div>

      <div class="card-expiration mb-16">
        <p class="text-xs">{{ trans.interval }}</p>
        <p v-if="!!subscription?.price?.interval">
          <template v-if="subscription.price.interval === 'month'">
            {{ trans.monthly }}
          </template>
          <template v-else>
            {{ trans.yearly }}
          </template>
        </p>
        <p v-else>No data available</p>
      </div>
    </div>

    <button
      :disabled="loadingBillingLink"
      class="btn btn-primary w-100 mb-24 py-12"
      @click="billingLink">
      <span v-if="loadingBillingLink">{{ trans.buttonLoadingLabel ?? 'Loading' }}</span>
      <span v-else>{{ trans.billingButtonText ?? '' }}</span>
    </button>

    <button
      :disabled="loadingLogout"
      class="btn btn-primary w-100 py-12"
      @click="logout"
    >
      <span v-if="loadingLogout">{{ trans.buttonLoadingLabel ?? 'Loading' }}</span>
      <span v-else>{{ trans.buttonLogout ?? 'Logout' }}</span>
    </button>
  </div>
</template>

<script>
import api from '@assets/js/front/checkout/api';

export default {
  name: 'VSubscriberBilling',
  props: {
    trans: {
      required: true,
    },
  },
  data() {
    return {
      subscription: {},
      loadingLogout: false,
      loadingBillingLink: false,
    };
  },
  mounted() {
    this.loadSubscription();
  },
  methods: {
    async loadSubscription() {
      try {
        const subscription = await api.subscription.retrieve();

        if (!!subscription && Object.keys(subscription).length > 0) {
          this.subscription = subscription;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async logout() {
      try {
        this.loadingLogout = true;

        await api.auth.logout();

        window.location.href = '/';
      } catch (e) {
        console.error(e);
      } finally {
        this.loadingLogout = false;
      }
    },
    async billingLink() {
      try {
        this.loadingBillingLink = true;

        const link = await api.user.retrieveBilling();

        window.open(link.url, '_blank');
      } catch (e) {
        console.error(e);
      } finally {
        this.loadingBillingLink = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.billing-data {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: minmax(auto, auto);

  .plan {
    grid-column: 1/3;
    grid-row: 1;
  }
}
</style>
